// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OSSAr","footer":"styles_footer__gyOJV","passCodeTooltip":"styles_passCodeTooltip__3B9Pm"};